import React from "react";
import {
    Box, Typography, Paper,  Chip
} from "@mui/material";
import GroupWorkIcon from '@mui/icons-material/GroupWork';


type AssociatedOperatorsProps = {
    associated_operators: string[];
}

export default function AssociatedOperators({ associated_operators }: AssociatedOperatorsProps) {
    return (
        <Paper variant="outlined" sx={{ flex: 1, p: 2, borderRadius: 2, bgcolor: '#fafafa' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 1, display: 'flex', alignItems: 'center', gap: 1 }}><GroupWorkIcon fontSize="small" color="primary" /> Associated Operators</Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                {associated_operators?.map((op, i) => <Chip key={i} label={op} size="small" color="primary" variant="filled" />)}
            </Box>
        </Paper>
    );
}